<template>
  <div class="rt-lookup" style="display:inline-block">
    <el-button type="primary" :disabled="disabled" :v-show="visible" @click="showLookupDialog" style="color:white">{{buttonText}}</el-button>
    <js-lookup-dialog ref="lookupDialog" :title="title==null?buttonText:title" :entity="entity" :checkSelectable="checkSelectable"
    v-bind:condition="condition" :request-url="dialogRequestUrl"
    :name-field="nameField" :id-field="idField" :display-fields="dialogDisplayFields"
    :orderby-fields="dialogOrderbyFields"
    :filter-fields="dialogFilterFields" @data-selected="handleDataSelected"
    :searchPlaceholder="searchPlaceholder"></js-lookup-dialog>
  </div>

</template>

<script>
import JsLookupDialog from "./lookup-chooser-dialog";

export default {
  name: "JsLookup",
  props: {
    buttonText:null,
    title:null,
    value: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible:{
        type:Boolean,
        default:true
    },
    multiple:{
        type:Boolean,
        default:false
    },
    entity: {
      type: String,
      required: true
    },
    condition: String,
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    disa: false,
    searchPlaceholder:String,
    checkSelectable:{
      type:Boolean,
      default:false
    }
  },
  components: {
    "js-lookup-dialog": JsLookupDialog
  },
  computed: {
  },
  data() {
    return {
    };
  },

  rules: {},
  methods: {
    showLookupDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.$emit("data-selected", val);
    }
  },
  watch: {

    methods: {
      showLookupDialog() {
        this.$refs.lookupDialog.show();
      },
      handleDataSelected(val) {
        this.$emit("data-selected", val);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// lookup-chooser.vue?4edc391e